import { Injectable } from '@angular/core';
import { SetDisplayingLanguages } from './translation-editor.actions';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TranslationEditorStateModel } from '../../../model';
import { mainLanguageCodesArray } from '../../../config';

@State<TranslationEditorStateModel>({
  name: 'translationEditor',
  defaults: {
    displayingLanguages: mainLanguageCodesArray,
  },
})
@Injectable()
export class TranslationEditorState {
  @Selector()
  static displayingLanguages(state: TranslationEditorStateModel): Array<string> {
    return state.displayingLanguages;
  }

  @Action(SetDisplayingLanguages)
  setDisplayingLanguages(
    { getState, patchState }: StateContext<TranslationEditorStateModel>,
    { payload }: { payload: Array<string> }
  ): void {
    patchState({
      ...getState(),
      displayingLanguages: payload,
    });
  }
}
